import { ApolloError } from '@apollo/client';
import {
  useCreateEnterpriseDutchiePosLoyaltyMemberMutation,
  GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationFn,
} from 'types/graphql';

export type UseEnterpriseDutchieLoyaltyReturn = {
  createEnterpriseDutchiePosLoyaltyMember: GqlCreateEnterpriseDutchiePosLoyaltyMemberMutationFn;
  loading: boolean;
  error: ApolloError | undefined;
  called: boolean;
};

export default function useEnterpriseDutchieLoyalty(): UseEnterpriseDutchieLoyaltyReturn {
  const [
    createEnterpriseDutchiePosLoyaltyMember,
    { loading, error, called },
  ] = useCreateEnterpriseDutchiePosLoyaltyMemberMutation();

  return {
    createEnterpriseDutchiePosLoyaltyMember,
    loading,
    error,
    called,
  };
}

export { useEnterpriseDutchieLoyalty };
